<h3 mat-dialog-title>Add a Bill Payment Bank Account</h3>

<!-- loading -->
<mat-dialog-content class="small-content" *ngIf="!isPreferencesLoaded">
    <div class="d-loading">
        <div class="loader">Loading ...</div>
    </div>
</mat-dialog-content>

<!-- blocked -->
<mat-dialog-content class="small-content" *ngIf="isPreferencesLoaded && !isManualAddEnabled">
    <h3>Temporarily Restricted</h3>
    <p>Please contact PayHOA to enable creation of bill pay accounts for this organization.</p>
</mat-dialog-content>

<!-- normal view, step 1 (terms and conditions) -->
<ng-container *ngIf="isPreferencesLoaded && isManualAddEnabled && !isTermsAgreedTo && isMemberDataLoaded">
    <mat-dialog-content>
        <div class="card mb-0">
            <div class="card-header"><h2>Terms and Conditions</h2></div>
            <div class="card-body">
                <p>In order to use the Bill Pay service, you are required to agree to the terms and conditions
                    below.</p>

                <p class="terms">
                    You represent and warrant, that your use of the Service or the Website shall not in any way,
                    directly or indirectly: a) violate any law, statute, contract or regulation relating to money
                    laundering, illegal gambling activities, support for terrorist activities, fraud or theft, and/or
                    (b) violate any of these Terms of Service. PayHOA will cooperate fully with law enforcement in the
                    detection or prosecution of illegal activities to the fullest extent permitted or required by
                    applicable law.
                </p>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button [attr.aria-label]="'Cancel'" (click)="cancelTermAgreement()" class="btn btn-outline-secondary" [disabled]="isAgreeInFlight">
            Cancel
        </button>
        <button [attr.aria-label]="'I agree'" (click)="saveTermAgreement()" class="btn btn-primary" [disabled]="isAgreeInFlight">
            I agree
        </button>
    </mat-dialog-actions>
</ng-container>

<!-- normal view, step 2 (set the amount) -->
<ng-container *ngIf="isPreferencesLoaded && isManualAddEnabled && isTermsAgreedTo && isMemberDataLoaded">
    <mat-dialog-content>
        <p>
            After adding your bank account, it will take 2-3 days to confirm your bank account ownership.
            Watch your account for 2 small deposits and come back to enter them here.
            Once your account is confirmed, you can use it to pay bills here.
        </p>

        <form [formGroup]="model">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                        <label>
                            Account Description *
                        </label>
                        <input formControlName="description"
                               name="description"
                               class="form-control"
                               required
                               type="text"/>
                        <div class="text-danger" *ngIf="isFieldInvalid('description')">{{errorMessage}}</div>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                        <label>
                            Signatory *
                        </label>
                        <input formControlName="signatory"
                               name="signatory"
                               class="form-control"
                               required
                               type="text"/>
                        <div class="text-danger" *ngIf="isFieldInvalid('signatory')">{{errorMessage}}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                        <label>
                            Routing Number (9 digits) *
                        </label>
                        <input formControlName="routingNumber"
                               name="routingNumber"
                               [maxlength]="9"
                               [minlength]="9"
                               class="form-control"
                               required
                               type="text"/>
                        <div class="text-danger" *ngIf="isFieldInvalid('routingNumber')">{{errorMessage}}</div>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                        <label>
                            Account Number *
                        </label>
                        <input formControlName="accountNumber"
                               name="accountNumber"
                               class="form-control"
                               required
                               type="text"/>
                        <div class="text-danger" *ngIf="isFieldInvalid('accountNumber')">{{errorMessage}}</div>
                    </div>
                </div>
            </div>

            <re-captcha
                #recaptchaComponent
                *ngIf="!jwt.isTest"
                (resolved)="captchaResolved($event)"
                siteKey="{{siteKey}}"
            ></re-captcha>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button [attr.aria-label]="'Cancel'" mat-dialog-close class="btn btn-outline-secondary">
            Cancel
        </button>
        <button [attr.aria-label]="'Add bank account'" (click)="saveBankInfo()" class="btn btn-primary" [disabled]="isSubmitInFlight">
            Add bank account
        </button>
    </mat-dialog-actions>
</ng-container>
